import React from 'react'
import Header from '../../../../Components/Header'
import Pick from './Pick'
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';


const Editpick = () => {
      const location = useLocation();
        console.log('Location state:', location.state); 
  
      const { pick_id } = location.state || {};
      console.log(pick_id,"pick_id_first");
      

  return (
    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
       <Helmet>
				<title>Picklist - Edit</title>
			</Helmet>
       <Header />
      <div className="container-fluid maindiv d-flex flex-column " style={{ flexGrow: '1' }}>
        <Pick  pick_id={pick_id} />
       </div>
           </div>

  )
}

export default Editpick